export const listFlows = (store) => store.flow.list?.map((flow) => ({
  label: flow.name,
  value: flow.id,
  description: flow.description,
}));

export const listFlowsLoading = (store) => store.flow.loading;

export const selectUserFlows = (store, userId) => store.flow.user?.[userId];
